import React from 'react'
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { CSVDownload } from 'react-csv'
import CSVExporterFactory from '../../managers/csv_export/csv_exporter_factory'

let data = []

const CsvExportButton = (props) => {
  const tooltip = <Tooltip id='tooltip'>Export to CSV</Tooltip>

  if (props.isFetching) {
    return (
      <Button
        style={{ backgroundColor: '#fff', borderColor: '#e7eaec' }}
        className='fadeIn btn btn-sm cursor-default btn-default'
      >
        <i className='fa fa-clock-o' /> <span className='h6'>Working on CSV...</span>
      </Button>
    )
  }

  if (props.results.length) {
    data = CSVExporterFactory.create(props.exporter, props.results, props.header).export()
  }
  const btnColor = props.isActive ? '#e6e6e6' : '#fff'
  return (
    <>
      <OverlayTrigger placement='top' overlay={tooltip}>
        <Button
          style={{ backgroundColor: btnColor }}
          className='btn btn-sm btn-white'
          onClick={() => props.handleMenuClick(props.aria_expanded)}
        >
          <i className='fa fa-table' />
        </Button>
      </OverlayTrigger>
      {props.results.length > 0 && (
        <CSVDownload className='csv-download' target='_self' filename={'test.csv'} data={data} />
      )}
    </>
  )
}

export default CsvExportButton
